import i18n from '@/plugins/i18n';
import type { DataTableHeader } from '@/types/vuetify';

export function createBotUsageStatsTableHeaders(nameTitleKey = 'botUsageStats.columns.name'): DataTableHeader[] {
    const t = i18n.global.t;

    return [
        {
            title: t(nameTitleKey),
            value: 'name',
            key: 'name',
            align: 'start',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('botUsageStats.columns.botCount'),
            value: 'botCount',
            key: 'botCount',
            align: 'end',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('botUsageStats.columns.botPerc'),
            value: 'botPerc',
            key: 'botPerc',
            align: 'end',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('botUsageStats.columns.botCountActive'),
            value: 'botCountActive',
            key: 'botCountActive',
            align: 'end',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('botUsageStats.columns.botPercActive'),
            value: 'botPercActive',
            key: 'botPercActive',
            align: 'end',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('botUsageStats.columns.betCount'),
            value: 'betCount',
            key: 'betCount',
            align: 'end',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('botUsageStats.columns.betPerc'),
            value: 'betPerc',
            key: 'betPerc',
            align: 'end',
            sortable: true,
            nowrap: true,
        },
    ];
}
